import {makeStyles} from '@material-ui/core/styles';

export default makeStyles({
    media:{
        height:250,
    }
})